import { useState } from "react";
import { AiFillStar } from "react-icons/ai";
import {
  BiCartAdd,
  BiDotsVerticalRounded,
  BiEditAlt,
  BiTrash,
} from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../redux/cartSlice";
import { deleteDataFunc } from "../redux/dataSlice";
import { modalFunc } from "../redux/modalSlice";

const ProductCard = ({ dt }) => {
  const [openEdit, setOpenEdit] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const updateFunc = () => {
    dispatch(modalFunc());
    setOpenEdit(false);
    navigate(`/?update=${dt?.id}`);
  };

  const deleteFunc = () => {
    dispatch(deleteDataFunc(dt?.id));
    setOpenEdit(false);
  };

  return (
    <div className="w-full relative card-surface rounded-lg overflow-hidden flex flex-col h-[420px]">
      <div className="h-52 overflow-hidden relative">
        <img
          className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-500"
          src={dt?.url}
          alt={dt?.name}
        />
        <div className="absolute top-3 left-3">
          <span className="bg-[#893168] text-white text-[10px] tracking-widest px-2.5 py-1 rounded font-bold uppercase">
            {dt?.category || "General"}
          </span>
        </div>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="mb-4">
          <div className="flex items-center gap-1.5 mb-2">
            <div className="flex text-yellow-500">
              {[...Array(5)].map((_, i) => (
                <AiFillStar
                  key={i}
                  size={14}
                  className={
                    i < Math.floor(dt?.rating || 4)
                      ? "text-yellow-500"
                      : "text-gray-600"
                  }
                />
              ))}
            </div>
            <span className="text-xs text-gray-500 font-bold ml-1">
              {dt?.rating || "4.0"}
            </span>
          </div>
          <h3 className="text-lg font-bold text-[#eaeaea] leading-tight mb-2 line-clamp-1">
            {dt?.name}
          </h3>
          <p className="text-gray-500 text-sm line-clamp-2 h-10">
            {dt?.description ||
              "High quality product from our curated catalog."}
          </p>
        </div>

        <div className="flex items-center justify-between mt-auto">
          <div>
            <p className="text-2xl font-black text-white">${dt?.price}</p>
            <p
              className={`text-[10px] font-black tracking-tighter uppercase ${dt?.stock > 0 ? "text-emerald-500" : "text-red-500"}`}
            >
              {dt?.stock > 0 ? `${dt.stock} units available` : "Out of stock"}
            </p>
          </div>
          <button
            onClick={() => dispatch(addToCart(dt))}
            disabled={dt?.stock === 0}
            className="h-11 px-5 rounded-md bg-[#893168] hover:bg-[#4a1942] disabled:bg-gray-800 disabled:opacity-30 text-white transition-all flex items-center gap-2 font-bold active:scale-95"
          >
            <BiCartAdd size={20} />
            <span className="text-xs uppercase">Add</span>
          </button>
        </div>
      </div>

      <div className="absolute top-3 right-3">
        <button
          onClick={() => setOpenEdit(!openEdit)}
          className="w-8 h-8 flex items-center justify-center rounded bg-black/40 text-white border border-white/10 hover:bg-black/60 transition-colors"
        >
          <BiDotsVerticalRounded size={18} />
        </button>
      </div>

      {openEdit && (
        <div className="absolute top-12 right-3 w-36 bg-[#2e1c2b] border border-[#893168]/30 p-1.5 z-20 shadow-2xl rounded">
          <button
            onClick={updateFunc}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-[#4a1942] rounded transition-colors font-medium"
          >
            <BiEditAlt size={16} />
            Edit
          </button>
          <button
            onClick={deleteFunc}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-500 hover:bg-red-500/10 rounded transition-colors font-medium"
          >
            <BiTrash size={16} />
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
